import { Portal, PortalHost } from "@-/com.npmjs.react-native-teleport";
import type { ReactNode } from "react";

const WEB_PAGE_CONTROLS_HOST_NAME = "web-primary-controls-strip-page-controls";

/** Keeps a page's controls in the web header while preserving their page context. */
export function WebPrimaryControlsStripPageControls({ children }: { children: ReactNode }) {
  return (
    <Portal className="pointer-events-auto" hostName={WEB_PAGE_CONTROLS_HOST_NAME}>
      {children}
    </Portal>
  );
}

export function WebPrimaryControlsStripPageControlsHost() {
  return <PortalHost className="shrink-0" name={WEB_PAGE_CONTROLS_HOST_NAME} />;
}
